'use strict';

module.exports = {
    DELETE_PORTAL: 'DELETE_PORTAL',
    ASSIGN_TENANT_TO_PORTAL: 'ASSIGN_TENANT_TO_PORTAL',
    UNASSIGN_TENANT_TO_PORTAL: 'UNASSIGN_TENANT_TO_PORTAL'
};